import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const serviceDropdownViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map